import {useEffect, useRef, useState} from 'react';
import {copyToClipboard} from '../utils/common';

const COPIED_TIMEOUT_S = 1.5;
type UseCopyToClipboardProps = {
  value?: string | number;
  seconds?: number;
};
function useCopyToClipboard({
  value,
  seconds = COPIED_TIMEOUT_S,
}: UseCopyToClipboardProps) {
  const [isCopied, setIsLinkCopied] = useState(false);
  const timeoutRef = useRef<ReturnType<typeof setTimeout>>();

  useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  const copy = () => {
    if (!value) return;
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    copyToClipboard(value);
    setIsLinkCopied(true);
    timeoutRef.current = setTimeout(() => {
      setIsLinkCopied(false);
    }, seconds * 1000);
  };

  return {isCopied, copy};
}

export {useCopyToClipboard};
